import React from 'react'
import styles from '../../styles/styles.module.css'

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  errorMsg?: React.ReactElement | string
  prefixIcon?: React.ReactNode
}

const Input: React.FC<Props> = ({ errorMsg, prefixIcon, ...props }) => {
  return (
    <div className="inputWrapper">
      <div className="prefixInline">
        {prefixIcon}
        <input {...props} />
      </div>
      {errorMsg && <div className={styles.errorMsg} data-i18n={errorMsg}>
        {errorMsg}
      </div>}
    </div>
  )
}

export default Input
